module.exports = __webpack_public_path__ + "static/integration-window-febd3345ec7841742143bbc2f9fc6c39.svg";